import Vue from "vue";
import axios from "axios";
import VModal from 'vue-js-modal';
import "vue-notifyjs/themes/default.css";
import VueTheMask from 'vue-the-mask'

import "lightgallery.js";
import "lightgallery.js/dist/css/lightgallery.css";

import App from "./App";
import store from "./store";
import router from "./router";
import PaperDashboard from "./plugins/paperDashboard";
import Tenant from "./mixins/tenant";

Vue.use(VueTheMask);
Vue.use(PaperDashboard);
Vue.use(VModal, {componentName: 'modal'});
Vue.mixin(Tenant);

Vue.prototype.$http = axios.create({
  baseURL: "https://api.globalfibra.com.br",
  headers: {
    common: {
      authorization: `bearer ${store.state.auth.accessToken}`
    },
  },
});
store.$http = Vue.prototype.$http;

// send to login if not authenticated
router.beforeEach(async (to, from, next) => {
  if (from.name == undefined) {
    try {
      await store.dispatch("fetchTenant");
      await Vue.prototype.$http.get("auth/user");
    } catch (err) {
      store.commit("logout");
    }
  }

  const toName = to.name.toLowerCase();
  if (toName !== "login" && !store.state.auth.accessToken) {
    next({name: "Login"});
  } else if (!toName.includes('contrato') && !toName.includes('lead') && !toName.includes('cliente') && !toName.includes('ponto') && !toName.includes('atendimentos') && !toName.includes('visualizar atendimento') && ['supervisor'].includes(store.state.auth.user.role)) {
    next({name: "contratos"});
  } else if (!toName.includes('contrato') && !toName.includes('lead') && !toName.includes('cliente') && !toName.includes('ponto') && ['operator'].includes(store.state.auth.user.role)) {
    next({name: "contratos"});
  } else if (!toName.includes('cadastrar um novo lead') && ['salesperson'].includes(store.state.auth.user.role)) {
    next({name: "cadastrar um novo lead"});
  } else if (!toName.includes('carro') && ['logistics'].includes(store.state.auth.user.role)) {
    next({name: "movimentacao-carros"});
  } else {
    next();
  }
});

new Vue({store, router, render: h => h(App)}).$mount("#app");
